import React from 'react';
export function SkeletonChart({ barCount = 5, height = 260 }) {
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col rounded-2xl bg-white p-6 shadow-sm"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mb-6 flex w-full items-center justify-between h-[32px]"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "h-8 w-40 rounded bg-slate-200 animate-pulse"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center gap-4 w-fit"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex gap-2"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "h-12 w-16 rounded-full bg-slate-200 animate-pulse"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "h-12 w-16 rounded-full bg-slate-200 animate-pulse"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "h-12 w-32 rounded-full bg-slate-200 animate-pulse"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "flex gap-2"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "h-12 w-16 rounded-full bg-slate-200 animate-pulse"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "h-12 w-16 rounded-full bg-slate-200 animate-pulse"
    })))), /*#__PURE__*/ React.createElement("div", {
        style: {
            height
        },
        className: "flex flex-col justify-end h-[260px]"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex-1 flex flex-col justify-between mb-4"
    }, Array.from({
        length: 4
    }).map((_, i) => /*#__PURE__*/ React.createElement("div", {
        key: i,
        className: "border-t border-slate-100"
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "flex items-end justify-between gap-3"
    }, Array.from({
        length: barCount
    }).map((_, i) => /*#__PURE__*/ React.createElement("div", {
        key: i,
        className: "flex items-end gap-1"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-3 bg-slate-200 rounded animate-pulse",
        style: {
            height: `${60 + i * 20}px`
        }
    }), /*#__PURE__*/ React.createElement("div", {
        className: "w-3 bg-slate-300 rounded animate-pulse",
        style: {
            height: `${30 + i * 15}px`
        }
    }))))));
}
